//IMPORTAÇÕES
import React, { useState, useEffect, useRef } from 'react'
import { Button, Form } from 'react-bootstrap'

// ICONES
import { setaDropdown } from '../../../utils/alternanciaIcones'
// SPINNER
import SpinerVeye from '../../spinnerVeye/spinnerVeye.js'

/*  COMO USAR
    Importe a modal para dentro do componente que irá fazer uso dela.
    ex: import SelectFormaEnvio from '../../componentesModais/selects/selectFormaEnvio'

    Crie um hook apropriado para esconder e exibir a mensagem quando necessário.
    ex: const [revelarSelectFormaEnvio, setRevelarSelectFormaEnvio] = useState(false)

    Após isso, posicione-a dentro do return do seu componente e passe os props para
    customizar o conteúdo da mensagem da seguinte forma. É interessante utilizar um
    <Button/> com uma função onClick, dentro de um >Form.Group/> para que o campo
    se mantenha similar aos campos de texto normais.
    ex: <Form.Group>
            <Form.Label>
                <div className="fonte-cor-1 label-campo">FormaEnvio {iconeAsterisco}</div>
            </Form.Label>
            { revelarSelectFormaEnvio === false &&
                <Button name="cdFormaEnvio" className="campo-texto-cor-3 campo-select" onClick={() => setRevelarSelectFormaEnvio(!revelarSelectFormaEnvio)}>
                    <div className="fonte-cor-1 label-campo">{dsFormaEnvio}</div>
                    <img className="campo-select-icone-desativado" src={setaDropdown()} alt="drop" />
                </Button>
            }
            { revelarSelectFormaEnvio === true &&
                <SelectFormaEnvio
                    setRevelarSelectFormaEnvio={setRevelarSelectFormaEnvio} //Hook para fechar a modal
                    setCdFormaEnvio={setCdFormaEnvio} //Código do FormaEnvio
                    setDsFormaEnvio={setDsFormaEnvio} //Nome do FormaEnvio
                    dsFormaEnvio={dsFormaEnvio} 
                    phFormaEnvio={phFormaEnvio} //Placeholder para mostrar o valor original em caso de edição
                >
                </SelectFormaEnvio>
            }
        </Form.Group>*/

export default function SelectFormaEnvio(props) {
  const [spinAtivo, setSpinAtivo] = useState(true)
  const [selectClass, setSelectClass] = useState(
    props.styleClass || 'campo-select'
  )

  const modal = useRef()

  const handleClickFora = (e) => {
    if (!modal.current.contains(e.target)) {
      handleCancelar()
    }
  }

  function handleFormaEnvio(FormaEnvio) {
    props.setDsFormaEnvio(FormaEnvio)
    handleCancelar()
  }

  function handleCancelar() {
    props.setRevelarSelectFormaEnvio(false)
  }

  useEffect(() => {
    setSpinAtivo(true)
    setSpinAtivo(false)
    document.addEventListener('mousedown', handleClickFora)
    return () => document.removeEventListener('mousedown', handleClickFora)
  }, [])

  return (
    <Form ref={modal}>
      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}
      <Button
        name="cdTipoPessoa"
        className={`campo-texto-cor-3 ${selectClass}`}
        onClick={() => props.setRevelarSelectFormaEnvio(false)}
      >
        <div className="fonte-cor-1 label-campo">{props.dsFormaEnvio}</div>
        <img
          className="campo-select-icone-ativado"
          src={setaDropdown()}
          alt="drop"
        />
      </Button>
      <div className="campo-select-triangulo-cor-1 campo-select-triangulo-position-fixed" />
      <div className="width-300px campo-texto-cor-3 campo-select-corpo-position-fixed">
        <ul className="campo-select-lista">
          <li>
            <div
              className="campo-select-opcao campo-select-opcao-1"
              onClick={() => handleFormaEnvio('Aguardar próximo pedido')}
            >
              <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">
                Aguardar próximo pedido
              </span>
            </div>
            <div className="campo-select-divisor-cor-1 campo-select-divisor" />
          </li>
          <li>
            <div
              className="campo-select-opcao campo-select-opcao-1"
              onClick={() => handleFormaEnvio('Carta')}
            >
              <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">
                Carta
              </span>
            </div>
            <div className="campo-select-divisor-cor-1 campo-select-divisor" />
          </li>
          <li>
            <div
              className="campo-select-opcao campo-select-opcao-1"
              onClick={() => handleFormaEnvio('PAC')}
            >
              <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">
                PAC
              </span>
            </div>
            <div className="campo-select-divisor-cor-1 campo-select-divisor" />
          </li>
          <li>
            <div
              className="campo-select-opcao campo-select-opcao-1"
              onClick={() => handleFormaEnvio('Retirar na Virtueyes')}
            >
              <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">
                Retirar na Virtueyes
              </span>
            </div>
            <div className="campo-select-divisor-cor-1 campo-select-divisor" />
          </li>
          <li>
            <div
              className="campo-select-opcao campo-select-opcao-1"
              onClick={() => handleFormaEnvio('Sedex')}
            >
              <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">
                Sedex
              </span>
            </div>
            <div className="campo-select-divisor-cor-1 campo-select-divisor" />
          </li>
          <li>
            <div
              className="campo-select-opcao campo-select-opcao-1"
              onClick={() => handleFormaEnvio('Sedex 10')}
            >
              <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">
                Sedex 10
              </span>
            </div>
            <div className="campo-select-divisor-cor-1 campo-select-divisor" />
          </li>

          <li>
            <div
              className="campo-select-opcao campo-select-opcao-1"
              onClick={() => handleFormaEnvio('Sedex 12')}
            >
              <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">
                Sedex 12
              </span>
            </div>
            <div className="campo-select-divisor-cor-1 campo-select-divisor" />
          </li>
          <li>
            <div
              className="campo-select-opcao campo-select-opcao-1"
              onClick={() => handleFormaEnvio('Transportadora')}
            >
              <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">
                Transportadora
              </span>
            </div>
            <div className="campo-select-divisor-cor-1 campo-select-divisor" />
          </li>
          <li>
            <div
              className="campo-select-opcao campo-select-opcao-1"
              onClick={() => handleFormaEnvio('Outro')}
            >
              <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">
                Outro
              </span>
            </div>
          </li>
        </ul>
      </div>
    </Form>
  )
}
